// kapigen version 0.1.34
// eslint-disable
// namespace Kaggle.Sdk.Users.Discord:
export var DiscordConfig;
(function(DiscordConfig) {
    DiscordConfig["UNSPECIFIED"] = "unspecified";
    DiscordConfig["ROLE_EXPERT_NAME"] = "roleExpertName";
    DiscordConfig["ROLE_MASTER_NAME"] = "roleMasterName";
    DiscordConfig["ROLE_GRANDMASTER_NAME"] = "roleGrandmasterName";
    DiscordConfig["ROLE_STAFF_NAME"] = "roleStaffName";
    DiscordConfig["ROLE_KAGGLER_NAME"] = "roleKagglerName";
    DiscordConfig["ROLE_KAGGLE_X_COHORT_3_MENTOR"] = "roleKaggleXCohort3Mentor";
    DiscordConfig["ROLE_KAGGLE_X_COHORT_3_MENTEE"] = "roleKaggleXCohort3Mentee";
    DiscordConfig["CATEGORY_COMPETITIONS"] = "categoryCompetitions";
    DiscordConfig["CATEGORY_COMPETITIONS_ARCHIVED"] = "categoryCompetitionsArchived";
})(DiscordConfig || (DiscordConfig = {}));
export var DiscordConfigWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "DISCORD_CONFIG_UNSPECIFIED":
            default:
                return DiscordConfig.UNSPECIFIED;
            case "DISCORD_CONFIG_ROLE_EXPERT_NAME":
                return DiscordConfig.ROLE_EXPERT_NAME;
            case "DISCORD_CONFIG_ROLE_MASTER_NAME":
                return DiscordConfig.ROLE_MASTER_NAME;
            case "DISCORD_CONFIG_ROLE_GRANDMASTER_NAME":
                return DiscordConfig.ROLE_GRANDMASTER_NAME;
            case "DISCORD_CONFIG_ROLE_STAFF_NAME":
                return DiscordConfig.ROLE_STAFF_NAME;
            case "DISCORD_CONFIG_ROLE_KAGGLER_NAME":
                return DiscordConfig.ROLE_KAGGLER_NAME;
            case "DISCORD_CONFIG_ROLE_KAGGLE_X_COHORT_3_MENTOR":
                return DiscordConfig.ROLE_KAGGLE_X_COHORT_3_MENTOR;
            case "DISCORD_CONFIG_ROLE_KAGGLE_X_COHORT_3_MENTEE":
                return DiscordConfig.ROLE_KAGGLE_X_COHORT_3_MENTEE;
            case "DISCORD_CONFIG_CATEGORY_COMPETITIONS":
                return DiscordConfig.CATEGORY_COMPETITIONS;
            case "DISCORD_CONFIG_CATEGORY_COMPETITIONS_ARCHIVED":
                return DiscordConfig.CATEGORY_COMPETITIONS_ARCHIVED;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case DiscordConfig.UNSPECIFIED:
            case 0:
            default:
                return "DISCORD_CONFIG_UNSPECIFIED";
            case DiscordConfig.ROLE_EXPERT_NAME:
            case 1:
                return "DISCORD_CONFIG_ROLE_EXPERT_NAME";
            case DiscordConfig.ROLE_MASTER_NAME:
            case 2:
                return "DISCORD_CONFIG_ROLE_MASTER_NAME";
            case DiscordConfig.ROLE_GRANDMASTER_NAME:
            case 3:
                return "DISCORD_CONFIG_ROLE_GRANDMASTER_NAME";
            case DiscordConfig.ROLE_STAFF_NAME:
            case 4:
                return "DISCORD_CONFIG_ROLE_STAFF_NAME";
            case DiscordConfig.ROLE_KAGGLER_NAME:
            case 5:
                return "DISCORD_CONFIG_ROLE_KAGGLER_NAME";
            case DiscordConfig.ROLE_KAGGLE_X_COHORT_3_MENTOR:
            case 6:
                return "DISCORD_CONFIG_ROLE_KAGGLE_X_COHORT_3_MENTOR";
            case DiscordConfig.ROLE_KAGGLE_X_COHORT_3_MENTEE:
            case 7:
                return "DISCORD_CONFIG_ROLE_KAGGLE_X_COHORT_3_MENTEE";
            case DiscordConfig.CATEGORY_COMPETITIONS:
            case 8:
                return "DISCORD_CONFIG_CATEGORY_COMPETITIONS";
            case DiscordConfig.CATEGORY_COMPETITIONS_ARCHIVED:
            case 9:
                return "DISCORD_CONFIG_CATEGORY_COMPETITIONS_ARCHIVED";
        }
    }
};
